function namedNode (namedNode) {
  return '<' + namedNode.value + '>'
}

module.exports = namedNode
